class AboutJs {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    // VALUEのスマホスライダー
    const topicsSwiper = document.querySelector('.js-about-value-swiper');
    new Swiper(topicsSwiper, {
      slidesPerView: 'auto',
      pagination: {
        el: '.js-about-value-swiper__pagination',
        type: 'progressbar'
      }
    })

    let mm = gsap.matchMedia();

    // フリーランスなのに・・・固定表示（横スクロール）
    const notFreeWrap = '.js-not-free-wrap';
    const notFreeContent = '.js-not-free-text';
    const paginationBar = '.js-not-free-pagination__bar';

    const contentWidth = document.querySelector(notFreeContent).scrollWidth; // 横スクロールに必要な全体の幅を取得

    const delayScroll = 300; // 固定後300px分スクロールしたら横スクロールを開始

    gsap.to(notFreeContent, {
      scrollTrigger: {
        trigger: notFreeWrap,
        start: "top top", // 固定を開始するタイミング
        end: () => `+=${contentWidth + delayScroll}`, // スクロールの終了位置を設定
        scrub: true,
        pin: notFreeWrap, // 固定
        onUpdate: (self) => {
          const progress = self.progress;

          // 横スクロールの制御
          if (progress >= delayScroll / self.end) {
            gsap.to(notFreeContent, {
              x: (contentWidth - window.innerWidth) * (progress - delayScroll / self.end) / (1 - delayScroll / self.end),
              overwrite: 'auto'
            });
          }

          // バーの伸縮の制御
          const adjustedProgress = (progress - delayScroll / self.end) / (1 - delayScroll / self.end);
          if (adjustedProgress > 0) {
            gsap.to(paginationBar, {
              height: `${adjustedProgress * 100}%`, // 横スクロールに応じてバーの高さを調整
              overwrite: 'auto'
            });
          } else {
            gsap.to(paginationBar, {
              height: `0%`, // スクロールが遅れているときはバーを0%にリセット
              overwrite: 'auto'
            });
          }
        },
      }
    })

    const notFreeText = '.js-not-free-content';
    const notFreeTitle = '.js-not-free-title';
    const notFreeBird = '.js-not-free-bird';
    mm.add('(min-width:769px)', () => {
      // フリーランスなのに・・・のテキストサイズの変更
      gsap.to(notFreeTitle, {
        fontSize: '5rem',
        scrollTrigger: {
          trigger: notFreeWrap,
          start: 'top +=200px',
          end: 'top top',
          scrub: 1,
          // toggleActions: 'play none reverse none'
        }
      })
    })
    // フリーランスなのに・・・のopacitycity調整
    gsap.to(notFreeText, {
      opacity: 1,
      scrollTrigger: {
        trigger: notFreeWrap,
        start: 'top top',
        end: 'top -=100px',
        scrub: 1,
        // toggleActions: 'play none reverse none'
      }
    })
    gsap.to(notFreeBird, {
      opacity: 1,
      scrollTrigger: {
        trigger: notFreeWrap,
        start: 'top top',
        end: 'top -=100px',
        scrub: 1,
        // toggleActions: 'play none reverse none'
      }
    })

  }
}

class PostJs {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    // 画像（img）にwidth属性がある場合のサイズ制御
    const imgElements = document.querySelectorAll('img');
    imgElements.forEach((item, key) => {
      const itemWidth = item.getAttribute('width');
      item.style.width = itemWidth + 'px';
    })
  }
}

class RecruitJs {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    $('.js-rectuitAco').click(function() {
      $(this).next().next().slideToggle();
    })
  }
}

class TopJs {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const topicsSwiper = '.js-top-topics-swiper';
    new Swiper(topicsSwiper, {
      slidesPerView: 'auto',
      pagination: {
        el: '.js-top-topics-swiper__pagination',
        type: 'progressbar'
      }
    })
    const mvSwiper = '.js-mv-swiper';
    let mm = gsap.matchMedia();
    mm.add('(min-width:769px)', () => {
      new Swiper(mvSwiper, {
        loop: true,
        allowTouchMove: false,
        speed: 10000,
        slidesPerView: 'auto',
        autoplay: {
          delay: 0
        },
      })
    })
    mm.add('(max-width:768px)', () => {
      new Swiper(mvSwiper, {
        loop: true,
        direction: 'vertical',
        allowTouchMove: false,
        speed: 7000,
        slidesPerView: 'auto',
        autoplay: {
          delay: 0
        },
      })
    })

    const videoElement = document.getElementById('video');
    const marquee = document.querySelector('.js-marquee');

    videoElement.addEventListener('play', function() {
      marquee.classList.add('is-play');
    });

    setTimeout(() => {
      marquee.classList.add('is-play');
    }, 500);
  }
}

const store = {
  isDesktop: window.innerWidth >= 768 // 初期値はブレイクポイントかどうかで決定
};

function updateIsDesktop() {
  store.isDesktop = window.innerWidth >= 768;
}

window.addEventListener('resize', updateIsDesktop);

window.alpine = {
  store,
  updateIsDesktop
};
class BreadcrumbScroll {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const breadEle = document.querySelector("." + this.el);
    const footerEle = document.querySelector('.js-footer');
    const mm = gsap.matchMedia();
    mm.add('(min-width:769px)', () => {
      gsap.to(breadEle, {
        opacity: 0,
        scrollTrigger: {
          trigger: footerEle,
          start: 'top 130%',
          end: 'top bottom',
          toggleActions: 'play none reverse none',
        }
      })
    })
  }
}

class CircleNumList {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    document.querySelectorAll('.c-circle-num-list').forEach(list => {
      // 各リストごとに番号をリセットして再設定
      list.querySelectorAll('.c-circle-num-list__item').forEach((item, index) => {
        const circledNumbers = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'];
        if (index < circledNumbers.length) {
          item.style.setProperty('--circle-num', `"${circledNumbers[index]}"`);
        } else {
          // circledNumbers の長さを超えた場合の対応（必要に応じて拡張）
          item.style.setProperty('--circle-num', `"${index + 1}"`);
        }
      });
    });
  }
}

class ContactAccept {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const dataAccept = document.querySelector('[data-accept]').dataset.accept;
    const acceptEle = document.querySelector('.js-contact-accept');
    acceptEle.href = dataAccept;
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class HeaderAnimation {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const headerEle = document.querySelector("." + this.el);
    const mm = gsap.matchMedia();
    mm.add('(min-width:769px)', () => {
      gsap.to(headerEle, {
        scrollTrigger: {
          trigger: 'body',
          start: 'top -=10px',
          end: 'top +=300px',
          toggleActions: 'play none reverse none',
          onEnter: () => headerEle.classList.add('is-scroll'),
          onLeaveBack: () => headerEle.classList.remove('is-scroll'),
        }
      })
    })
  }
}

// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}
class TextSwiper {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const textSwipers = document.querySelectorAll("." + this.el);
    textSwipers.forEach((item, key) => {
      const speed = item.dataset.speed || 15000;
      new Swiper(item, {
        speed: speed,
        loop: true,
        slidesPerView: 'auto',
        autoplay: {
          delay: 0
        }
      })
    })
  }
}


(() => {

})();

//DOMContentLoaded
$(() => {
  new TextSwiper('js-text-swiper');
  new ContactAccept('js-contact-accept');
  new TopJs('js-top');
  new AboutJs('js-about');
  new HeaderAnimation('js-main-header-scroll');
  new BreadcrumbScroll('js-breadcrumb-scroll');
  new CircleNumList('js-circle-num-list');
  new PostJs('js-post-content');
  new RecruitJs('p-recruit');
});

//images resources loaded
$(window).on('load', () => {
  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
});